var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 11.9898V6.47429C2.6665 4.05205 2.6665 2.84093 3.44755 2.08843C4.2286 1.33594 5.48568 1.33594 7.99984 1.33594C10.514 1.33594 11.7711 1.33594 12.5521 2.08843C13.3332 2.84093 13.3332 4.05205 13.3332 6.47429V11.9898C13.3332 13.5271 13.3332 14.2957 12.8179 14.5708C11.8202 15.1036 9.94864 13.3261 9.05983 12.7909C8.54437 12.4805 8.28663 12.3253 7.99984 12.3253C7.71304 12.3253 7.45531 12.4805 6.93984 12.7909C6.05104 13.3261 4.17948 15.1036 3.18174 14.5708C2.6665 14.2957 2.6665 13.5271 2.6665 11.9898Z",
    fill: "#1B1A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingBookmark);
export default __webpack_public_path__ + "static/media/pricing-bookmark.b6a844b34e584a10804aa6a294410959.svg";
export { ForwardRef as ReactComponent };